<template>
    <div class="login-page">
        <div class="tag">&lt;h1&gt;</div>
        <h1>Login</h1>
        <div class="tag">&lt;/h1&gt;</div>
        <form class="form" @submit.prevent="auth">
            <div class="form__conteiner">
                <div class="form__field">
                    <input class="form__input" type="text" name="user_login" v-model="login" required />
                    <span
                        class="form__field-lable"
                        :class="{ 'form__field-lable--active': login }"
                    >Login</span>
                </div>
                <div class="form__field">
                    <input class="form__input" type="password" name="user_password" v-model="password" required />
                    <span
                        class="form__field-lable"
                        :class="{ 'form__field-lable--active': password }"
                    >Password</span>
                </div>
            </div>
            <div class="form__btn">
                <BtnOk @clickokay="auth()" />
            </div>
        </form>
    </div>
</template>

<script>
import BtnOk from "@/components/form/BtnOk.vue";
import qs from "qs";

export default {
    components: {
        BtnOk
    },

    data() {
        return {
            login: "",
            password: ""
        };
    },

    methods: {
        close() {
            close();
        },
        auth() {
            let params = {
                login: this.login,
                password: this.password
            };
            this.axios
                .post("/api/auth/", qs.stringify(params))
                .then(() => {
                    this.$router.push("/");
                })
                .catch(function(error) {
                    console.log(error);
                });
        }
    }
};
</script>

<style lang="sass" scoped>
h1
    text-align: center
.form__conteiner
    display: flex
    justify-content: space-around
.form__field,
.btn
    background-color: $grey-l
    margin-right: 0 !important
</style>
